import { render, staticRenderFns } from "./tambahrubrik.vue?vue&type=template&id=23fc2e68&"
import script from "./tambahrubrik.vue?vue&type=script&lang=js&"
export * from "./tambahrubrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports